import React from 'react';
import { Link } from 'react-router-dom';
import instagramIcon from '../../assets/images/common/common_footer_instagram.svg';
import kakaoIcon from '../../assets/images/common/common_footer_kakao.svg';

function Footer() {
  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      // 헤더 높이를 고려하여 스크롤 위치 조정 (헤더 높이는 80px)
      const offsetTop = section.offsetTop - 40;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-black border-t border-gray-200 pt-0 md:pt-8 pb-2">
      <div className="w-full mb-10 mx-auto px-12 md:px-20 lg:px-8">
        <div className="lg:flex lg:flex-row justify-between items-start lg:items-start">
          {/* 왼쪽 영역 - 회사 정보 */}
          <div
            className="lg:w-1/2 flex flex-col items-start lg:justify-center lg:items-left lg:items-center order-1">
            <div className="flex flex-col justify-center items-start lg:items-center">
              <div
                className="text-sm text-white leading-relaxed text-left lg:text-left mt-12 md:mt-[50px] lg:mt-[100px] mb-[20px] lg:mb-[120px]">
                <div
                  className="text-xl lg:text-xl leading-[160%] font-['Pretendard'] font-bold mb-[12px] lg:mb-[20px]">(주)챙기고
                </div>
                <div className="text-xl lg:text-xl leading-[160%] font-['Pretendard'] mb-[2px] lg:mb-[8px]">대표 : 박태홍</div>
                <div className="text-xl lg:text-xl leading-[160%] font-['Pretendard'] mb-[2px] lg:mb-[8px]">사업자등록번호 :
                  197-87-02701
                </div>
                <div className="text-xl lg:text-xl leading-[160%] font-['Pretendard'] mb-[2px] lg:mb-[8px]">통신판매업 신고번호 : 제
                  2022-서울강남-05228 호
                </div>
                <div className="text-xl lg:text-xl leading-[160%] font-['Pretendard'] mb-[2px] lg:mb-[8px]">주소 : 서울특별시 강남구
                  테헤란로 6길 33, 2층
                </div>
                <div className="text-xl lg:text-xl leading-[160%] font-['Pretendard'] mb-[2px] lg:mb-[8px]">Tel :
                  070-4271-0801
                </div>
              </div>
            </div>
          </div>
          {/* 오른쪽 영역 - 소개/문의/방침, SNS */}
          <div
            className="lg:w-1/2 lg:flex lg:flex-col lg:justify-center lg:items-center order-2">
            <nav
              className="flex justify-between lg:flex-col lg:justify-center lg:items-start lg:space-y-6 py-[32px] lg:py-0 lg:mt-[100px]">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('about');
                }}
                className="text-2xl md:text-2xl lg:text-xl font-bold transition-colors duration-200 text-white hover:underline"
              >
                About
              </a>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('business');
                }}
                className="text-2xl md:text-2xl lg:text-xl font-bold transition-colors duration-200 text-white hover:underline"
              >
                Business
              </a>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('howwework');
                }}
                className="text-2xl md:text-2xl lg:text-xl font-bold transition-colors duration-200 text-white hover:underline"
              >
                How we work
              </a>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('contact');
                }}
                className="text-2xl md:text-2xl lg:text-xl font-bold transition-colors duration-200 text-white hover:underline"
              >
                Contact
              </a>
            </nav>
          </div>
        </div>
      </div>
      <div
        className="text-lg lg:text-xl text-white mb-[16px] text-center">Copyright &copy; chaenggigo
        Co. Ltd. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;